import { createI18n } from 'vue-i18n'
import { defaultLang, getLocale } from 'src/common/functions'

let i18nObject = null

export default async (ctx) => {
  const { app, store } = ctx

  const locale = store.getters.getUserLanguage || getLocale()

  const repeatLoad = (langIso, count = 1, defaultL = false) =>
    import(/* webpackChunkName: "lang-[request]" */ `../i18n/${langIso}/index.js`)
      .then((res) => {
        i18nObject = createI18n({
          legacy: false,
          locale,
          globalInjection: true,
          fallbackLocale: defaultLang,
          messages: {
            [langIso]: res.default,
          },
        })

        app.use(i18nObject)
      })
      .catch((err) => {
        console.log(`DEBUG: Error lang loaded: ${count}`, err)
        if (defaultL) {
          return count > 0 ? repeatLoad(defaultLang, count - 1, true) : null
        }
        return count > 0 ? repeatLoad(langIso, count - 1) : repeatLoad(defaultLang, 5, true)
      })

  return repeatLoad(locale, 5)
}

export { i18nObject }
